'use client';
import { reconnect } from '@bigmi/client';
import { useEffect } from 'react';
export const useReconnect = (config) => {
    useEffect(() => {
        reconnect(config);
    }, [config]);
};
//# sourceMappingURL=useReconnect.js.map